module.exports = new __parcel__URL__("seahorse-ios6.e27602f7.webp").toString();